var map = {
	"./2checkout.png": 3573,
	"./allipay.png": 731,
	"./baokim.png": 7924,
	"./blockchain.png": 1869,
	"./ccavenue.png": 7495,
	"./clickatell.png": 8003,
	"./coinbase.png": 9139,
	"./content-images.psd": 1170,
	"./dashboard.png": 4639,
	"./dhl.png": 1923,
	"./dwolla.png": 4880,
	"./fedex.png": 9417,
	"./googlepay.png": 6830,
	"./icontact.png": 2404,
	"./jobsheet.png": 5673,
	"./kanban.png": 8014,
	"./mailchimp.png": 9653,
	"./mailgun.png": 9442,
	"./mobile-app.png": 7039,
	"./nochex.png": 3712,
	"./notify.png": 8544,
	"./paypal.png": 734,
	"./paytm.png": 9800,
	"./quickpay.png": 5286,
	"./sendgrid.png": 721,
	"./skrill.png": 6718,
	"./slack.png": 5339,
	"./telegram.png": 5970,
	"./twillo.png": 108,
	"./upi.png": 2727,
	"./ups.png": 701,
	"./worldpay.png": 3421,
	"./zoho.png": 989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;